import HttpService from "config/http";

function buildQueryString(params) {
  const searchParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.append(key, value);
    }
  });

  const queryString = searchParams.toString();
  return queryString ? `?${queryString}` : "";
}

export default class BffService {
  constructor(props) {
    this.api = new HttpService({
      ...props,
      baseUrlOverride:
        process.env.REACT_APP_BFF_URL_API || process.env.REACT_APP_BASE_URL_API,
    });
  }

  getForms = (params) => {
    return this.api.get(`/admin/forms${buildQueryString(params)}`);
  };

  getForm = (slug) => {
    return this.api.get(`/admin/forms/${slug}`);
  };

  createForm = (body) => {
    return this.api.post(`/admin/forms`, body);
  };

  updateForm = (slug, body) => {
    return this.api.put(`/admin/forms/${slug}`, body);
  };

  updateFormStatus = (slug, isCurrent) => {
    return this.api.patch(`/admin/forms/${slug}/status`, { isCurrent });
  };

  getCompanyForms = (companyId) => {
    return this.api.get(`/admin/companies/${companyId}/forms`);
  };

  updateCompanyForms = (companyId, assignments) => {
    return this.api.put(`/admin/companies/${companyId}/forms`, assignments);
  };

  getScreeningReportUploadUrl = (screeningUuid) => {
    return this.api.post(`/screenings/${screeningUuid}/report-upload-url`);
  };

  confirmScreeningReportUpload = (screeningUuid) => {
    return this.api.post(`/screenings/${screeningUuid}/report-upload-confirm`);
  };
}
